<div>
  <!-- this if condition needs to be added in the above line.-> *ngIf="isLoggedIn()" -->
<div class="catcontainer" style="margin-left: 5px;width:1376px;margin-top: 10px;height: fit-content;border-radius: 5px;" *ngIf="isLoggedIn()">
  
<div  style="height:158px;border-radius:5px;width:1376px;">
  <div style="background-color:lightgray;height:91px;border-radius:12px;width:1355px;margin-top:5px;margin-left: 5px;">
    <table width="1366px" border="0" align="left" style="margin-left:5px;">
      <tr>
          <td width="400px" align="left">
              <img src="assets/Accenture-Logo-1.png" style="width:200px;" id="picker6" />
          </td>
          <td width="550px" align="center"><span style="font-size: 40px;color: black; text-align:center; font-weight:bold;white-space: nowrap;">Vulnerability Management Portal</span></td>
          <td width="450px" align="right" rowspan="1">
              <img src="assets/Logo_AccentureTechGCC.png" style="width:120px;height:90px;margin-right: 14px;" id="picker6" />
          </td>
      </tr>
    </table >
  </div>
 
        <table align="center" width="1345px" style="margin-top: 5px;" *ngIf="isShown">
          <tr>
        <td style="width: 125px;padding-left: 170px;"><button class="buttonHeaderHome" *ngIf="gccUser" [routerLink]="['home']">Vulnerabilities</button></td>        
        <!-- <td style="width: 125px;"> <button class="buttonHeaderHome" *ngIf="appAdmin()" [routerLink]="['newvulnerability/0000']">New Vulnerability</button></td> -->        
        <!-- <td style="width: 125px;"> <button class="buttonHeaderHome"  [routerLink]="['newassessment/0000']">Assessments</button></td> -->
        <td style="width: 125px;"> <button class="buttonHeaderHome" *ngIf="gccUser" [routerLink]="['assessment-home']">Assessments</button></td>        
        <td style="width: 125px;"> <button class="buttonHeaderHome" *ngIf="gccUser" [routerLink]="['maintenance/0000']">Maintenance</button></td>
        <td style="width: 125px;"> <button class="buttonHeaderHome" *ngIf="gccUser">Dashboard</button></td>
        <td style="width: 125px;"> <button class="buttonHeaderHome" *ngIf="gccUser"><a style="color:white;text-decoration:none" (click)="onReportClick()">Reports</a></button></td>
        <!-- <td style="width: 125px;"> <button class="buttonHeaderHome" *ngIf="gccUser"><a style="color:white;text-decoration:none" href="https://skmsnewppd.accenture.com/sites/GCC/Operations%20Documents/Forms/AllItems.aspx?RootFolder=%2Fsites%2FGCC%2FOperations%20Documents%2FReporting%2FVM%20Portal&FolderCTID=0x012000E8A7AAC75294CE48826BA7AB451DD814&View=%7B1ED0D10E%2D8BBD%2D4D1E%2DBACB%2D99BE41024247%7D" target='_blank'>Reports</a></button></td> -->
        <td style="width: 125px;"> <button class="buttonHeaderHome" *ngIf="isAdmin" [routerLink]="['Admin']">Admin</button></td>    
        <td style="width: 125px;"> <button class="buttonHeaderHome"  [routerLink]="['UserView']">User-Vulnerability</button></td>
        <!-- <td style="width: 125px;"> <button class="buttonHeaderHome" *ngIf="gccUser" [routerLink]="['userview-assessment/0']">User-Assessment</button></td> -->
        <td style="float: right"><button class="buttonHeaderHome" *ngIf="isLoggedIn()" (click)="logout()">LogOut</button></td>
        </tr>
      </table>    
      <!-- *ngIf="isLoggedIn()" -->
</div>
<!-- <div style="margin-left: 5px;" *ngIf="isShown">
<table align="center">
  <tr>
<td><button class="buttonHeaderHome"  [routerLink]="['home']">Home</button></td>        
<td> <button class="buttonHeaderHome"  [routerLink]="['newvulnerability/0000']">New Vulnerability</button></td> -->
<!-- <td> <button class="buttonHeaderHome"  [routerLink]="['newassessment/0000']">Assessments</button></td> -->
<!-- <td> <button class="buttonHeaderHome"  [routerLink]="['maintenance/0000']">Maintenance</button></td>
<td> <button class="buttonHeaderHome">Dashboard</button></td>
<td> <button class="buttonHeaderHome">Reports</button></td>
<td> <button class="buttonHeaderHome">Admin</button></td>
<td> <button class="buttonHeaderHome" (click)="toggleShow()" [routerLink]="['UserView']" *ngIf="appAdmin()">UserView</button></td>
<td><button class="buttonHeaderHome" *ngIf="isLoggedIn()" (click)="logout()">LogOut</button></td>
</tr>
</table>
  </div> -->

<!-- <mat-toolbar color="primary">  

  <div class="toolbar-spacer"></div>

  <a mat-button [routerLink]="['profile']">Profile</a>

  <button mat-raised-button *ngIf="!loginDisplay" (click)="login()">Login</button>

</mat-toolbar>


<div class="container">
  This is to avoid reload during acquireTokenSilent() because of hidden iframe 
  <router-outlet *ngIf="!isIframe"></router-outlet>
</div> -->
<router-outlet></router-outlet>
</div>
<footer class="footer" *ngIf="isLoggedIn()">
  © 2022 - GCC VM All Rights Reserved. Accenture Highly Confidential. For Internal User Only. Build Release 1.0 
© Please be aware that any personal data that you and others provide through this tool may be processed by Accenture. The protection of your personal data is very important to Accenture. Accenture is committed to keeping your personal data secure, and processing it in accordance with, applicable data protection laws and our internal policies, including Accenture’s Global Data Privacy Policy 0090. Before providing any personal data through this tool, Accenture invites you to carefully read its privacy statement, which includes important information on why and how Accenture is processing your personal data.
</footer>
</div>
